import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description =
  'ドイツ本国の開発チームと現地協議のうえ、Tennis-Pointアプリを日本市場向けにローカライズ。AWSを東京リージョンへ移行・Salesforce認証基盤を導入しイオングループのセキュリティ要件に適合させ、ストアレビュー好評を獲得した海外アプリ日本展開の開発事例です。'

const ogpImg = 'https://aitria.co.jp/images/img/cases/tennispointapp/ogp_tennispointapp.png'

export const tennispointappPageMeta: PageMeta = {
  title: '欧州アプリの日本市場ローカライズ｜AWS移行・日本向けUX設計・Salesforce認証の開発事例 | Aitria（アイトリア）',
  description,
  keyword: 'UX/UI モバイルアプリ システム化 DX推進 フロントエンド開発',
  image: ogpImg,
  url: `${SITE_URL}/cases/tennispointapp/`,
}

export const tennispointappSchema = buildCaseStudySchema({
  slug: 'tennispointapp',
  pageTitle: tennispointappPageMeta.title,
  description: tennispointappPageMeta.description,
  headline: 'クラウドネイティブなシステム構築と日本向けUX/UI設計でアプリのローカライズを支援',
  alternativeHeadline: 'イオン・シグナ・スポーツ・ユナイテッド株式会社',
  primaryImage: ogpImg,
  images: [ogpImg, 'https://aitria.co.jp/images/img/cases/tennispointapp/top.png'],
  clientName: 'イオン・シグナ・スポーツ・ユナイテッド株式会社',
  breadcrumbLabel: 'クラウドネイティブなシステム構築と日本向けUX/UI設計でアプリのローカライズを支援',
})
